import { Option } from "@inrev/core";

const NON_TEXT_CONTENT = /<(klipy-tag|hr)\b/i;
const INVISIBLE_CHARACTERS = /[\u00ad\u200b-\u200f\u2060]/g;

export const isEmptyRichTextHtml = (html: Option<string>) =>
	Option.isNone(html) ||
	(!NON_TEXT_CONTENT.test(html) &&
		html
			.replace(/<[^>]*>/g, "")
			.replace(/&nbsp;/g, "")
			.replace(INVISIBLE_CHARACTERS, "")
			.trim() === "");
